import { EventEmitter } from 'events'

const eventEmitter = new EventEmitter()

export default {
  on: (event: string | symbol, listener: (...args: any[]) => void) => {
    eventEmitter.on(event, listener)
    return () => {
      eventEmitter.removeListener(event, listener)
    }
  },
  emit: (event: string | symbol, ...args: any[]): boolean => {
    return eventEmitter.emit(event, args)
  },
}
